import type { ChangeEvent } from '@brighterly/lib-core-types/ui/inputs/interfaces'
import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface EmailReturn {
  mode: ComputedRef<InputMode>
  setEmail: (event: ChangeEvent) => void
}

export const useEmail = (): EmailReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const mode = computed(() => getMode(tutorApplicationStore.getShowErrors && (!tutorApplicationStore.email || !tutorApplicationStore.isEmailValid)))

  const setEmail = (event: ChangeEvent) => {
    tutorApplicationStore.setEmail(event.value)
    tutorApplicationStore.setEmailValid(event.valid)
  }

  return {
    mode,
    setEmail,
  }
}
